/**
 * Mixin shared by every dynamic contract section. Each section component reads the contract
 * model and the resolved feature flags from the parent's provide(), so authors don't have to
 * thread props through manually.
 *
 * Usage:
 *   <script>
 *   import sectionMixin from '../sectionMixin'
 *   export default { mixins: [sectionMixin], ... }
 *   </script>
 *
 * In templates, bind to `item.xxx` directly — that name is exposed as a computed below.
 */
export default {
  inject: {
    dynamicContract: {
      from: 'dynamicContract',
      default: () => null
    }
  },
  computed: {
    item() {
      return this.dynamicContract ? this.dynamicContract.item : {}
    },
    features() {
      return this.dynamicContract ? this.dynamicContract.features : {}
    },
    salesLineId() {
      return this.dynamicContract ? this.dynamicContract.salesLineId : null
    },
    readonly() {
      // Anything past Draft or Feedback is read-only for non-super users. Matches the
      // legacy detail pages' isReadonly() heuristic. Real per-field gating moves into
      // the per-section components during Phase 8 sign-off.
      const status = (this.item && this.item.status) || 'Draft'
      return status !== 'Draft' && status !== 'Feedback'
    }
  }
}
